import { useNavigate } from "react-router-dom";
import sortArrow from "../../../assets/images/sortArrow.svg";
import CustomPagination from "../../../components/pagination/CustomPagination";
import toast from "react-hot-toast";
import ENVIRONMENT from "../../../config/environment";
function Table({
  headerData,
  handleSort,
  selectedHeader,
  handleArrowSortClick,
  tableData,
  isPagination,
  page,
  setPage,
  size,
  setSize,
  total,
}: {
  headerData: any;
  handleSort: any;
  selectedHeader: any;
  handleArrowSortClick: any;
  tableData: any;
  isPagination?: boolean;
  page?: any;
  setPage?: any;
  size?: any;
  setSize?: any;
  total?: any;
}) {
  const navigate = useNavigate();

  const copyLink = (item: any) => {
    const path = `/help?detail=${item?._id}`;
    const baseUrl = ENVIRONMENT.publicSiteUrl;
    const fullUrl = `${baseUrl}${path}`;
    navigator.clipboard
      .writeText(fullUrl)
      .then(() => {
        console.log("Link copied to clipboard:", fullUrl);
        toast.success("Link copied to clipboard!");
      })
      .catch((err) => {
        // Error handling
        console.error("Failed to copy link:", err);
      });
  };
  return (
    <div>
      <table className="table-main table user-table">
        <thead>
          <tr className="table-head">
            {headerData?.map((item: any, index: number) => {
              return (
                <th key={index} style={{ padding: "1.4rem" }}>
                  {" "}
                  <span onClick={() => handleSort(item)}> {item?.label}</span>
                  {item.label === selectedHeader.label ? (
                    <span className="ml-1">
                      <img
                        id="roles-sort-icon"
                        onClick={handleArrowSortClick}
                        src={sortArrow}
                        alt="sort-icon"
                        style={{ verticalAlign: "initial", cursor: "pointer", zIndex: "99" }}
                      />
                    </span>
                  ) : null}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {tableData?.map((item: any, index: any) => {
            return (
              <tr
                key={index}
                className="table-row"
                onClick={() => {
                  if (item?.type !== "help") {
                    navigate(`/content/${item?.type}/${item?._id}`);
                  }
                }}
              >
                {headerData.map((col: any, colIndex: any) => (
                  <td
                    key={colIndex}
                    onClick={() => {
                      if (item?.type === "help" && col.id === "link") {
                        copyLink(item);
                      } else if (item?.type === "help" && col.id !== "link") {
                        navigate(`/content/help/${item?.type}/${item?._id}`);
                      } else {
                        navigate(`/content/${item?.type}/${item?._id}`);
                      }
                    }}
                  >
                    {item[col.id]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      {isPagination ? (
        <div className="mx-3">
          <CustomPagination page={+page} setSize={setSize} setpage={setPage} size={size} total={+total} filterCount={+total} />
        </div>
      ) : null}
    </div>
  );
}

export default Table;
